import { AfterViewInit, ChangeDetectionStrategy, Input, ChangeDetectorRef, Component, EventEmitter, inject, Output, ViewChild } from '@angular/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Mirko3Service } from '../mirko3.service';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog } from '@angular/material/dialog';
import { DialogConfermaComponent } from '../dialog-conferma/dialog-conferma.component';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-mirko3',
    imports: [MatFormFieldModule, MatInputModule, MatTableModule, MatButtonModule, CommonModule, MatDatepickerModule, MatProgressBarModule, MatPaginatorModule, MatIconModule,FormsModule],
    templateUrl: './mirko3.component.html',
    styleUrl: './mirko3.component.css',
    providers: [provideNativeDateAdapter()]
})
export class Mirko3Component implements AfterViewInit {




  @Input() idRichiesta: any;





  @Output() valueChanged = new EventEmitter<boolean>();

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }


  @ViewChild(MatPaginator) paginator: MatPaginator = new MatPaginator(new MatPaginatorIntl(), ChangeDetectorRef.prototype);


  qualifiche: Qualifica[] = [];
  selectedQualifiche: any[] = [];
  disponibilitaSessioneUVM: any[] = [];
  sessioneUVMScelta: Sessione | undefined;

  loadinDisponibilitaUVM: boolean = false;
  filtroDisponibilita: boolean = true;
  sceltaDisponibilita: boolean = false;

  displayedColumns: string[] = ['descrizione', 'action'];
  displayedColumnsDisponibilitaSessioneUVM: string[] = ['data', 'oraInizio', 'oraFine', 'operatoriBreve', 'action2'];
  dataSource: any;
  dataSoruceSelected: any;
  dataSoruceDisponibilitaSessioneUVM: any;



  get mostraFiltroDisponibilita() {
    return this.filtroDisponibilita;
  }

  get mostraSceltaDisponibilita() {
    return this.sceltaDisponibilita;
  }

  get mostraCaricamentoDisponibilitaUVM() {
    return this.loadinDisponibilitaUVM;
  }

  constructor(private mirko3Service: Mirko3Service, private cdr: ChangeDetectorRef) {

  }


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    this.dataSource.paginator = this.paginator;
  }

  ngOnInit(): void {
    this.fetchQualifiche();
  }

  back() {
    this.sceltaDisponibilita = false;
    this.filtroDisponibilita = true;
  }

  fetchQualifiche(): void {
    this.mirko3Service.getQualifiche().subscribe(
      (data) => {
        this.qualifiche = data;
        this.dataSource = new MatTableDataSource<Qualifica[]>(data);
        this.dataSource.paginator = this.paginator;
      },
      (error) => {
        console.error('Error fetching qualifiche:', error);
      }
    );
  }

  addToSelected(item: any): void {
    this.selectedQualifiche.push(item);
    this.dataSoruceSelected = new MatTableDataSource<Qualifica[]>(this.selectedQualifiche);
  }

  svuotaListaQualifiche() {
    this.selectedQualifiche = [];
    this.dataSoruceSelected = new MatTableDataSource<Qualifica[]>(this.selectedQualifiche);
  }

  rimuoviDaListaQualificheSelezionate(item: any) {
    console.log(item);
    if (item) {
      const index = this.dataSoruceSelected.data.indexOf(item);
      if (index > -1) {
        this.dataSoruceSelected.data.splice(index, 1);
        this.dataSoruceSelected = new MatTableDataSource(this.dataSoruceSelected.data);
      }
    }
  }



  uvmDuration: any;
  /** Data inizio ricerca sessioni UVM (default 15/02/2026). */
  dataInizioSessioneUVM: Date = new Date(2026, 1, 15);


  cercaDisponibilitaUVM(): void {

    console.log(this.selectedQualifiche);

    const requestBody: DisponibilitaUVMRequest = {
      durataSessioneUVM: this.uvmDuration,
      dataInizioSessioneUVM: this.formatDataInizioUVM(this.dataInizioSessioneUVM),
      qualifiche: this.selectedQualifiche
    };



    this.loadinDisponibilitaUVM = true;

    this.mirko3Service.getDisponibilitaUVM(requestBody).subscribe({
      next: (data: any[]) => {
        const sessioni = Array.isArray(data) ? data : [];
        this.dataSoruceDisponibilitaSessioneUVM = new MatTableDataSource<Sessione[]>(sessioni);
        this.loadinDisponibilitaUVM = false;
        this.filtroDisponibilita = false;
        this.sceltaDisponibilita = true;
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error('Error fetching disponibilità UVM:', err);
        this.loadinDisponibilitaUVM = false;
      }
    });
  }
  dialog = inject(MatDialog);


  openDialogSceltaSessioneUVM(sessioneUVMSelezionata: any): void {
    this.sessioneUVMScelta = sessioneUVMSelezionata;
    const dialogRef = this.dialog.open(DialogConfermaComponent, {
      data: {
        animal: 'panda',
        prova: 'AAAAAAAAAAAA'
      },
    });

    dialogRef.afterClosed().subscribe(
      data => {

        if (data === "Ok") {

          this.mirko3Service.updateStatoRichiestaSessioneUVM(this.idRichiesta, this.sessioneUVMScelta).subscribe(
            (data2) => {
              console.log(data2);
              this.valueChanged.emit(true);
            },
            (error2) => {
              console.error('Error fetching qualifiche:', error2);

            }
          );
        }

      }
    );







  }

  /** Formatta la data per l'API UVM (dd/MM/yyyy). */
  formatDataInizioUVM(d: Date): string {
    if (!d) return '15/02/2026';
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  }

  getOperatoriNomi(session: Sessione): string {
    const list = session?.operatori ?? [];
    return list.map((op: Operatore) => `${op.cognome ?? ''} ${op.nome ?? ''} (${op.qualifica?.descrizione ?? ''})`.trim()).filter(Boolean).join(', ') || '—';
  }
}




export interface Qualifica {
  id: number;
  codice: string;
  descrizione: string;
}

export interface Struttura {
  id: number;
  codice: string;
  descrizione: string;
}

export interface Operatore {
  id: string;
  cognome: string;
  nome: string;
  codiceFiscale: string;
  qualifica: Qualifica
}

export interface Sessione {
  id: number;
  data: string;
  oraInizio: string;
  oraFine: string;
  struttura: Struttura;
  operatoriBreve: string;
  operatori: Operatore[];
}


export interface DisponibilitaUVMRequest {
  durataSessioneUVM: number;
  dataInizioSessioneUVM: string;
  qualifiche: Qualifica[];
}

